



















import {
    Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';
import AnalyticStepItem from '@/components/dashboard/analytics/AnalyticStepItem.vue';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component({
    components: {
        AnalyticStepItem,
    },
})
export default class AnalyticSteps extends Mixins(IsMobileMixin) {
    @Prop({ default: [] }) stepList!: any[];

    public sizeNumber = 4;

    public gridList = 'xl';

    @Watch('innerWidth', { immediate: true })
    private onPersonChanged1(val: any, oldVal: any) {
        if (val > 900) {
            this.sizeNumber = 4;
            this.gridList = 'lg';
        } else if (val > 550) {
            this.sizeNumber = 6;
            this.gridList = 'md';
        } else {
            this.sizeNumber = 12;
            this.gridList = 'xs';
        }
    }
}
